import React, { CSSProperties } from 'react';
import icons from '../../assets/icons';
import { MIconName } from './MIcon.model';
import classes from './MIcon.module.scss';

type Props = {
  name: MIconName | string;
  size?: 's' | 'sm' | 'm' | 'l';
  className?: string;
  style?: CSSProperties;
  viewBox?: string;
};

const MIconView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return typeof props.name === 'string' ? (
    <svg
      className={`${classes['container']} ${props.size ? classes[`container--${props.size}`] : ''} ${props.className || ''}`.trim()}
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${props.viewBox ? props.viewBox : icons[props.name][0]}`}
      dangerouslySetInnerHTML={{ __html: icons[props.name][1] }}
      style={props.style}
    ></svg>
  ) : (
    props.name({
      className: `${classes['container']} ${props.size ? classes[`container--${props.size}`] : ''} ${props.className || ''}`.trim(),
      style: props.style,
    })
  );
};

MIconView.displayName = 'MIconView';
MIconView.defaultProps = {};

export default MIconView;
